import React from 'react'
import numeral from 'numeral'
import { isEmpty } from 'ramda'
import * as _ from 'recompose'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'

import Form from './../Form'
import BidPayments from '../Lot/PaymentSelect'
import { setPaymentData } from '../../store/reducers/payment'
import { clearPaymentMethods } from '../../store/reducers/paymentMethods'

// const formatExpiry = str => str.substring(4, 6) + '/' + str.substring(2, 4)

const PaymentCallback = ({
  fetching,
  onSubmit,
  onChange,
  intl,
  value,
  errors = {},
  currency,
  fromProfile,
  setAgreementOffer, agreementOffer,
}) => (
  <div className='SetBid-layout'>
    <div className='SetBid-layout__left'>
      <h1 className='Signin__title Head'>
        <FormattedMessage id='bid.make_payment' />
      </h1>
      <div className='Rate__form'>
        <Form
          noEnter
          noAutoFocus
          disableBtn
          disabled
          onInput={() => {}}
          placeholder={intl.formatMessage({ id: 'bid.bid' }) + (currency && (' ' + currency.symbol))}
          value={value ? numeral(value).format('0,0') + (currency && (' ' + currency.symbol)) : 0}
        />
      </div>
    </div>
    <div className='SetBid-layout__left'>
      <BidPayments error={errors.paymentMethod} onChange={onChange} fromProfile={fromProfile} setAgreementOffer={setAgreementOffer} agreementOffer={agreementOffer}/>
      <div style={{ marginTop: 24 }}>
        {errors.paymentMethod && <div style={{ marginBottom: 12 }} className='Text'>{errors.paymentMethod}</div>}
        {errors.agreements && <div style={{ marginBottom: 12 }} className='Text'>{errors.agreements}</div>}
        <button className='Region-submit' disabled={fetching} onClick={onSubmit}><FormattedMessage id='regions.done' /></button>
      </div>
    </div>
  </div>
)

const mapState = state => ({
  data: state.payment.data
})

const mapDispatch = { onChange: setPaymentData, clearPaymentMethods }

export default _.compose(
  injectIntl,
  connect(mapState, mapDispatch),
  _.withState('errors', 'setErrors', {}),
  _.withState('agreementOffer', 'setAgreementOffer', false),
  _.withHandlers({
    onSubmit: ({ onSubmit, data, setErrors, intl, agreementOffer }) => e => {
      e && e.preventDefault()

      const errors = {}
      if (!data.paymentMethod && !data.userPaymentId) errors['paymentMethod'] = intl.formatMessage({id: 'bid.choose_payment_method'})
      if (!agreementOffer) {errors.agreements = intl.formatMessage({ id: 'bid.accept_agreements' })}
      if (!isEmpty(errors)) {
        setErrors(errors)
        return null
      }

      onSubmit(data)
    }
  }),
  _.lifecycle({
    componentDidMount () {
      this.props.init()
    },
    componentWillUnmount () {
      this.props.clearPaymentMethods()
    }
  })
)(PaymentCallback)



// WEBPACK FOOTER //
// ./src/components/Payment/Callback.jsx